import { render, staticRenderFns } from "./ProfileUpdateForm.vue?vue&type=template&id=89c78588"
import script from "./ProfileUpdateForm.vue?vue&type=script&lang=js"
export * from "./ProfileUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports